(function () {
  var selector = [
    'a.kl_reviews__carousel__link',
    'a.kl_reviews__review__product_card__container'
  ].join(',');

  function getReviewLink(event) {
    var target = event.target;

    if (!(target instanceof Element)) {
      return null;
    }

    return target.closest(selector);
  }

  function blockReviewLink(event) {
    var link = getReviewLink(event);

    if (!link) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    return false;
  }

  document.addEventListener('click', blockReviewLink, true);
  document.addEventListener('auxclick', blockReviewLink, true);
  document.addEventListener('dblclick', blockReviewLink, true);

  document.addEventListener(
    'keydown',
    function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') {
        return;
      }

      blockReviewLink(event);
    },
    true
  );

  function removeReviewHrefs() {
    document.querySelectorAll(selector).forEach(function (link) {
      link.removeAttribute('href');
      link.removeAttribute('target');
      link.setAttribute('aria-disabled', 'true');
      link.setAttribute('tabindex', '-1');
      link.style.setProperty('cursor', 'default', 'important');
    });
  }

  removeReviewHrefs();

  var observer = new MutationObserver(removeReviewHrefs);

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  console.log('[Klaviyo blocker] Asset loaded');
})();